import { defineStore } from "pinia";
import _ from "lodash";

export class SidebarItem{
    /**
     *
     * @param id
     * @param options
     */
    constructor(id, options) {
        this.id = id;

        this.setTitle(_.get(options, 'title', null));

        this.icon = _.get(options, 'icon', false);

        this.setRoute(
            _.get(options, 'route', null),
            _.get(options, 'route_arguments', {}),
        );

        this.setRelatedRoutes(_.get(options, 'related_routes', []));

        this.active = _.get(options, 'active', this.active);

        this.setItems(_.get(options, 'items', []));

        this.setExternalLink(_.get(options, 'external_link', null));
    }

    setTitle(title){
        if(typeof title === 'string'){
            this.title = title;
        }
        else if(typeof title === 'function'){
            this.title = title();
        }
        else if(typeof title === 'object'){
            this.title = _.get(title, 'text') || _.get(title, 'title');
        }
    }

    setRoute(routeName, routeArguments) {
        if(routeName){
            this.route_name = routeName;
            this.route_arguments = routeArguments;
            this.route = route(routeName, routeArguments);
            this.active = route().current(routeName, routeArguments);
        }

        return this;
    }

    setRelatedRoutes(relatedRoutes) {
        this.related_routes = [];

        if(Array.isArray(relatedRoutes)) {
            this.related_routes = relatedRoutes;

            if(!!relatedRoutes.firstOf(routeName => route().current(routeName))) {
                this.active = true;
            }
        }

        return this;
    }

    setItems(items) {
        this.items = [];

        if(Array.isArray(items)){
            this.items = items.map(
                item => item instanceof SidebarItem? item : new SidebarItem(item)
            );

            if(!!items.firstOf(item => item.active)) {
                this.active = true;
            }
        }

        return this;
    }

    isRouteRelated(routeName) {
        return this.route_name === routeName || this.related_routes.inArray(routeName);
    }

    setExternalLink(link) {
        this.external_link = link;
    }
}

export const SidebarItems = defineStore('SidebarItems', {
    state: () => ({
        items: [],
    }),

    getters: {

    },

    actions: {
        setItems(items){
            this.items = items;
        },

        setItemActive(item, ancestors) {
            const isARelatedRouteActive = !!item.related_routes.firstOf(routeName => route().current(routeName));
            ancestors = ancestors || [];

            if(!(item.active || isARelatedRouteActive)){
                this.deactivateItems();

                item.active = true;
                ancestors = ancestors.map(ancestor => ancestor.active = true);

                return item;
            }

            return item;
        },

        deactivateItems(items) {
            items = items || this.items;

            items.forEach(item => {
                item.active = false;

                if(item.items.length > 0){
                    this.deactivateItems(item.items);
                }
            });
        },

        setActiveByRouteName(routeName, items, ancestors) {
            routeName = routeName || route().current();
            items = items || this.items;
            ancestors = ancestors || [];

            items.forEach(item => {
                if(item.isRouteRelated(routeName)){
                    this.setItemActive(item, ancestors);
                }
                else if(item.items.length > 0){
                    return this.setActiveByRouteName(routeName, item.items, [...ancestors, item]);
                }
            });
        },
    },
});
